import { OnInit, Input, OnChanges, Component, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { ImageCropperComponent } from './imageCropper.component';

export interface FileImagen {
  imagenBase64: string;
  type: string;
  name: string;
  extension: string;
  size: number;
}

@Component({
  selector: 'sx-image-uploader',
  templateUrl: './imageUploader.component.html',
  styleUrls: ['./imageUploader.component.css']
})
export class ImageUploaderComponent implements OnInit, OnChanges {
  // La imagen inicial
  @Input() imagen: string;
  @Input() deshabilitado: string;
  @Input() esBase64 = false;
  @Input() cols = 'col-md-10'; // Las cols de bootstrap que ocupará la imagen

  // Evento cuando el usuario acepta el cambio de imagen
  @Output() imagenCambiada: EventEmitter<FileImagen> = new EventEmitter();

  editando = false;
  localImagen: string;
  file: FileImagen = {
    name: null,
    extension: null,
    imagenBase64: null,
    size: 0,
    type: null,
  };

  constructor(private modalService: NgbModal) {}

  ngOnInit() {
    this.localImagen = this.imagen;
  }

  ngOnChanges(changes) {
    if (changes.imagen) {
      this.localImagen = changes.imagen.currentValue;
    }
  }

  /**
   * Abre el File Chooser (File Dialog)
   */
  openFileDialog() {
    $('#fileLoader').click();
  }

  openImageCropper() {
    this.modalService.open(ImageCropperComponent).result
      .then(
        (imagenBase64) => {
          if (imagenBase64) {
            this.editando = true;

            // Datos por default
            this.file.name = 'defaultName';
            this.file.size = 233;
            this.file.type = 'png';
            this.file.extension = 'png';

            this.setImagen(imagenBase64);
          }
        },
        (reason) => { /* Do nothing */ }
      );
  }

  /**
   * Callback que se llama cuando el usuario selecciona una imagen
   * desde el File Chooser o cierra el File Chooser sin seleccionar nada
   */
  onFileChange(event) {
    const seleccionoUnaImagen = event.target.files && event.target.files.length > 0;
    if (seleccionoUnaImagen) {
      const reader = new FileReader();
      const imagenFile = event.target.files[0];

      this.file.extension = imagenFile.name ? imagenFile.name.split('.').pop() : '';

      // Si el tipo de archivo subido no es valido, retornamos
      const acceptedTypes = ['png', 'jpg'];
      if (acceptedTypes.indexOf(this.file.extension) < 0) {
        return;
      }

      this.editando = true;

      this.file.name = imagenFile.name;
      this.file.size = imagenFile.size;
      this.file.type = imagenFile.type;

      // Se lee la imagen con un reader para mostrar el preview
      reader.readAsDataURL(imagenFile);

      reader.onload = (e: any) => {
        this.setImagen(e.target.result);
      };
    }
  }

  setImagen(base64Img: string) {
    // Obtengo solo la parte de la imagen que es base64
    this.localImagen = base64Img;
    this.file.imagenBase64 = this.localImagen.replace(/^data:image\/(png|jpeg);base64,/, '');

    if (this.esBase64) {
      this.localImagen = this.file.imagenBase64;
    }
  }

  /**
   * Emite que se ha cambiado la imagen
   */
  editarImagen() {
    // Emito la nueva imagen
    this.imagenCambiada.emit(this.file);

    this.restablecerUploader();
  }

  restablecerImagen() {
    this.restablecerUploader();
    this.localImagen = this.imagen;
  }

  restablecerUploader() {
    $('#fileLoader').val('');
    this.editando = false;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/fileUpload/imageUploader.component.ts